export class AutocompleteSettings {
  public stringsDs?: boolean;
  public textProperty?: string;
  public valueProperty?: string;
  public placeholder?: string;
  public serverPagination?: boolean;
  public showSearch?: boolean;
  public paginationSize?: number;

  constructor(init?: Partial<AutocompleteSettings>) {
    Object.assign(this, init);
  }
}
